export default "__VITE_ASSET__$p2dRCWH__"